const backToTopButtonObserver = new IntersectionObserver((entries) => {
  const backToTopButton = document.querySelector("#button-top");

  if (backToTopButton) {
    const entry = entries[0];
    backToTopButton.classList.toggle("opacity-0", entry.isIntersecting);
    backToTopButton.classList.toggle("opacity-100", !entry.isIntersecting);
    backToTopButton.classList.toggle(
      "pointer-events-none",
      entry.isIntersecting,
    );
  }
});

const backToTopLinkObserver = new IntersectionObserver((entries) => {
  const backToTopLink = document.querySelector("#link-top");

  if (backToTopLink) {
    const entry = entries[0];

    backToTopLink.classList.toggle("opacity-0", entry.isIntersecting);
    backToTopLink.classList.toggle("opacity-100", !entry.isIntersecting);
    backToTopLink.classList.toggle("pointer-events-none", entry.isIntersecting);
  }
});

const trackTocLinks = () => {

  // Track mobile TOC
  const mobileLinks = document.querySelectorAll(".toc-mobile a");
  mobileLinks.forEach((link) => {
    link.addEventListener("click", (event) => {
      document
        .querySelectorAll(".toc-mobile a[data-active]")
        .forEach((active) => {
          active.removeAttribute("data-active");
        });
      event.currentTarget.setAttribute("data-active", "");
    });
  });
};

const trackTocSections = () => {
  document.documentElement.classList.add("toc-loading");

  function initTocObserver() {
    const sections = document.querySelectorAll("section");
    const desktopLinks = document.querySelectorAll(".toc-desktop a");
    const mobileLinks = document.querySelectorAll(".toc-mobile a");

    // Helper function to clear active states
    const clearActiveStates = () => {
      desktopLinks.forEach((link) => link.removeAttribute("data-active"));
      mobileLinks.forEach((link) => link.removeAttribute("data-active"));
    };

    // Listen for hash changes and scroll events
    window.addEventListener("hashchange", () => {
      if (window.location.hash === "#top") {
        clearActiveStates();
      }
    });

    // Add scroll end detection
    let scrollTimeout;
    window.addEventListener(
      "scroll",
      () => {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(() => {
          if (window.scrollY === 0) {
            clearActiveStates();
          }
        }, 150); // Adjust timeout as needed
      },
      { passive: true },
    );

    if (sections.length) {
      const initialHash = window.location.hash;
      let isInitialLoad = true;
      let lastScrollY = window.scrollY;

      const observerOptions = {
        root: null,
        rootMargin: "-20% 0px -60% 0px",
        threshold: [0, 0.25, 0.5, 0.75, 1],
      };

      const observer = new IntersectionObserver((entries) => {
        if (isInitialLoad && initialHash) {
          isInitialLoad = false;
          return;
        }

        const currentScrollY = window.scrollY;
        //const isScrollingDown = currentScrollY > lastScrollY;
        lastScrollY = currentScrollY;

        // Filter for currently intersecting entries
        const visibleEntries = entries.filter((entry) => entry.isIntersecting);

        if (visibleEntries.length) {
          // Sort entries by their position in the viewport
          const sortedEntries = visibleEntries.sort((a, b) => {
            const aRect = a.boundingClientRect;
            const bRect = b.boundingClientRect;

            if (aRect.top >= 0 && bRect.top >= 0) {
              return aRect.top - bRect.top;
            }

            if (aRect.top < 0 && bRect.top >= 0) return 1;
            if (bRect.top < 0 && aRect.top >= 0) return -1;

            return bRect.top - aRect.top;
          });

          const topEntry = sortedEntries[0];
          const currentIndex = Array.from(sections).indexOf(topEntry.target);

          // Update TOC links
          const updateTocLinks = (links, index) => {
            links.forEach((link) => link.removeAttribute("data-active"));
            if (links[index]) {
              links[index].setAttribute("data-active", "");
            }
          };

          updateTocLinks(desktopLinks, currentIndex);
          updateTocLinks(mobileLinks, currentIndex);

          // Only scroll mobile TOC into view when scrolling down
          if (!isInitialLoad && mobileLinks[currentIndex]) {
            mobileLinks[currentIndex].scrollIntoView({
              behavior: "smooth",
              block: "nearest",
              inline: "start",
            });
          }
        }
      }, observerOptions);

      // Start observing with a slight delay to let the page settle
      setTimeout(() => {
        sections.forEach((section) => observer.observe(section));
        document.documentElement.classList.remove("toc-loading");
        isInitialLoad = false;
      }, 100);
    }
  }

  // Check if page is already loaded
  if (document.readyState === "complete") {
    initTocObserver();
  } else {
    // Wait for page to fully load
    window.addEventListener("load", initTocObserver);
  }
};

const localeSwitcher = () => {
  // Language-based redirects using cookie existence
  // When a user sets their language with the locale switcher,
  // we store a language-specific cookie e.g. "lang_es" or "lang_en"
  // Netlify redirects can check for the existence of these cookies
  // (not their values) to determine user's language preference
  // Example: Cookie=lang_en will match if lang_en cookie exists

  const langBtn = document.querySelector("#langBtn");
  const langNav = document.querySelector("#langNav");
  const localeGroup = document.querySelector("[data-locale-switcher-header]");

  if (langBtn && localeGroup) {
    // Toggle language menu
    langBtn.addEventListener("click", () => {
      const isActive = localeGroup.hasAttribute("data-active");
      
      if (isActive) {
        localeGroup.removeAttribute("data-active");
        langBtn.setAttribute("aria-expanded", "false");
      } else {
        localeGroup.setAttribute("data-active", "");
        langBtn.setAttribute("aria-expanded", "true");
      }
    });

    // Close menu when clicking outside
    document.addEventListener("click", (event) => {
      if (!langBtn.contains(event.target) && !langNav.contains(event.target)) {
        localeGroup.removeAttribute("data-active");
        langBtn.setAttribute("aria-expanded", "false");
      }
    });

    // Handle language selection and set cookie
    document.querySelectorAll("#langNav div div a").forEach((button) => {
      button.addEventListener("click", () => {
        const selectedLang = button.getAttribute("lang");
        helperHandleLanguageSwitch(selectedLang);
      });
    });

    // Set a cookie with a given name, value, and expiry (in days).
    const helperSetCookie = (name, value, days) => {
      const date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      const expires = "expires=" + date.toUTCString();
      document.cookie =
        name + "=" + encodeURIComponent(value) + ";" + expires + ";path=/;domain=openers-closers.com";
    };

    // Delete a cookie by name
    const helperDeleteCookie = (name) => {
      document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;domain=openers-closers.com";
    };

    // Retrieve a cookie by name. Returns empty string if not found.
    const helperGetCookie = (name) => {
      const decodedCookie = decodeURIComponent(document.cookie);
      const cookieArray = decodedCookie.split(";");
      const prefix = name + "=";

      for (let i = 0; i < cookieArray.length; i++) {
        let c = cookieArray[i].trim();
        if (c.indexOf(prefix) === 0) {
          return c.substring(prefix.length, c.length);
        }
      }
      return "";
    };

    // Get all cookies that start with a prefix
    const helperGetCookiesByPrefix = (prefix) => {
      const decodedCookie = decodeURIComponent(document.cookie);
      const cookieArray = decodedCookie.split(";");
      const matchingCookies = [];

      for (let i = 0; i < cookieArray.length; i++) {
        let c = cookieArray[i].trim();
        if (c.indexOf(prefix) === 0) {
          const cookieName = c.substring(0, c.indexOf("="));
          matchingCookies.push(cookieName);
        }
      }
      return matchingCookies;
    };

    // Main function to handle language preference logic
    const helperHandleLanguageSwitch = (langCode) => {
      // Delete all existing lang_ cookies to avoid conflicts
      const existingLangCookies = helperGetCookiesByPrefix("lang_");
      existingLangCookies.forEach((cookieName) => {
        helperDeleteCookie(cookieName);
      });

      // Set the new language-specific cookie (e.g., lang_es, lang_en)
      // This allows Netlify redirects to check for cookie existence per language
      const cookieName = `lang_${langCode}`;
      helperSetCookie(cookieName, "1", 365); // Set for 1 year
      console.log("Language preference set:", langCode);
    };
  }
};

const progressBar = () => {
  const progressBarElement = document.querySelector("#progress-bar div");
  const articleElement = document.querySelector("#instruction-content");

  if (progressBarElement && articleElement) {
    function progressBarScroll() {
      // Get the article's position and dimensions
      const articleRect = articleElement.getBoundingClientRect();

      // Calculate how far we've scrolled into the article
      const articleScrolled = -articleRect.top;

      // Calculate the scrollable height of the article
      // (total height minus viewport height)
      const articleTotalScrollable =
        articleElement.offsetHeight - window.innerHeight;

      // Calculate the percentage (constrain between 0-100)
      let scrollPercentage = Math.min(
        100,
        Math.max(0, (articleScrolled / articleTotalScrollable) * 100),
      );

      // Update the progress bar width
      progressBarElement.style.width = scrollPercentage + "%";
    }

    window.addEventListener("scroll", progressBarScroll, { passive: true });

    // Initial calculation
    progressBarScroll();
  }
};


// Hijack back to main site links if they contain the ref parameter from our domain
const enhanceBackLink = () => {
  const backLinks = document.querySelectorAll("[data-back-link]");

  if (!backLinks.length) return;

  try {
    const urlParams = new URLSearchParams(window.location.search);
    const refParam = urlParams.get("ref");

    if (!refParam) return;

    const decodedRef = decodeURIComponent(refParam);
    const url = new URL(decodedRef);

    if (
      url.hostname === "www.openers-closers.com" ||
      url.hostname === "openers-closers.com"
    ) {
      backLinks.forEach((backLink) => {
        backLink.href = decodedRef;
      });
    }
  } catch (error) {
    // Silently fail and keep default if invalid URL
  }
};

export {
  backToTopButtonObserver,
  backToTopLinkObserver,
  trackTocLinks,
  trackTocSections,
  localeSwitcher,
  progressBar,
  enhanceBackLink,
};

// example
// // Language switcher with cookie-based locale preference
// window.addEventListener("DOMContentLoaded", (event) => {
//   const langBtn = document.querySelector("#langBtn");
//   const langNav = document.querySelector("#langNav");
//   const localeGroup = document.querySelector("[data-locale-switcher-header]");

//   if (langBtn && localeGroup) {
//     // Toggle language menu
//     langBtn.addEventListener("click", () => {
//       const isActive = localeGroup.hasAttribute("data-active");
      
//       if (isActive) {
//         localeGroup.removeAttribute("data-active");
//         langBtn.setAttribute("aria-expanded", "false");
//       } else {
//         localeGroup.setAttribute("data-active", "");
//         langBtn.setAttribute("aria-expanded", "true");
//       }
//     });

//     // Close menu when clicking outside
//     document.addEventListener("click", (event) => {
//       if (!langBtn.contains(event.target) && !langNav.contains(event.target)) {
//         localeGroup.removeAttribute("data-active");
//         langBtn.setAttribute("aria-expanded", "false");
//       }
//     });

//     // Handle language selection and set cookie
//     document.querySelectorAll("#langNav div div a").forEach((button) => {
//       button.addEventListener("click", () => {
//         const selectedLang = button.getAttribute("lang");
//         handleLanguageSwitch(selectedLang);
//       });
//     });
//   }

//   // Set a cookie with a given name, value, and expiry (in days)
//   const setCookie = (name, value, days) => {
//     const date = new Date();
//     date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
//     const expires = "expires=" + date.toUTCString();
//     document.cookie =
//       name + "=" + encodeURIComponent(value) + ";" + expires + ";path=/;domain=openers-closers.com";
//   };

//   // Delete a cookie by name
//   const deleteCookie = (name) => {
//     document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;domain=openers-closers.com";
//   };

//   // Get all cookies that start with a prefix
//   const getCookiesByPrefix = (prefix) => {
//     const decodedCookie = decodeURIComponent(document.cookie);
//     const cookieArray = decodedCookie.split(";");
//     const matchingCookies = [];

//     for (let i = 0; i < cookieArray.length; i++) {
//       let c = cookieArray[i].trim();
//       if (c.indexOf(prefix) === 0) {
//         const cookieName = c.substring(0, c.indexOf("="));
//         matchingCookies.push(cookieName);
//       }
//     }
//     return matchingCookies;
//   };

//   // Main function to handle language preference logic
//   // Language-based redirects using cookie existence
//   // When a user sets their language with the locale switcher,
//   // we store a language-specific cookie e.g. "lang_es" or "lang_en"
//   // Netlify redirects can check for the existence of these cookies
//   // to determine user's language preference
//   const handleLanguageSwitch = (langCode) => {
//     // Delete all existing lang_ cookies to avoid conflicts
//     const existingLangCookies = getCookiesByPrefix("lang_");
//     existingLangCookies.forEach((cookieName) => {
//       deleteCookie(cookieName);
//     });

//     // Set the new language-specific cookie (e.g., lang_es, lang_en)
//     const cookieName = `lang_${langCode}`;
//     setCookie(cookieName, "1", 365); // Set for 1 year
//     console.log("Language preference set:", langCode);
//   };
// });